import React from 'react';
import SearchBox from '../../generic/searchbox/SearchBox';
import { useLocation } from 'react-router-dom';

import './style.scss'
import Links from '../../generic/header-links/Links';
import Profile from '../../generic/profile/Profile';

const Header = () => {

    const location = useLocation();

    return (
        <div className='header-container'>
            {location.pathname === '/dashboard/lend' && <Links />}
            {location.pathname === '/' && <SearchBox />}
            {location.pathname === '/dashboard/collect' && <Links />}
            <div className='header-container__profile'>
                <Profile />
            </div>
        </div>
    )
}

export default Header;
